module.exports = __webpack_public_path__ + "static/media/about-certificate-img1.d649621c.jpg";